import React from 'react';

const LoadingSpinner = ({ fullScreen = false }) => {
  // fullScreen true ise tüm ekranı kapla, değilse sadece içeriğin olduğu alanı kapla
  const containerClass = fullScreen
    ? "fixed inset-0 bg-gradient-to-br from-[#FFF5F5] via-white to-[#FFF5F5] flex items-center justify-center z-50"
    : "min-h-[calc(100vh-200px)] flex items-center justify-center py-20"; // Dikeyde ortala

  return (
    <div className={containerClass}>
      <div className="relative">
        <div className="animate-spin rounded-full h-24 w-24 border-4 border-red-200 border-t-red-600"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <img src="/logoupdown.svg" alt="Logo" className="h-12 w-12" />
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;